import { ImageCardBase as _ImageCard } from './ImageCard';
import { ImageCardMetadata } from './ImageCard.Metadata/ImageCard.Metadata';

export type { IImageCardProps } from './ImageCard';

export const ImageCard = Object.assign(_ImageCard, {
  Metadata: ImageCardMetadata
});
